import { render, staticRenderFns } from "./FormRender.vue?vue&type=template&id=b53e7186&scoped=true"
import script from "./FormRender.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormRender.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FormRender.vue?vue&type=style&index=0&id=b53e7186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53e7186",
  null
  
)

export default component.exports